import React from 'react';
import { Checkbox } from '@mui/material';

import { ArcCheckboxProps } from './types';

const ArcCheckbox: React.FC<ArcCheckboxProps> = (props) => {
  return <Checkbox {...props} />;
};

export default ArcCheckbox;